import {useTranslation} from "react-i18next";

function EarthSectionBase({
                              id,
                              background,
                              className = "",
                              children,
                          }) {
    const { t } = useTranslation();

    return (
        <section
            id={id}
            className={`earth-fullscreen-section earth-centered-section earth-layer ${className}`.trim()}
            style={{ background }}
        >
            {children}
        </section>
    );
}

export default EarthSectionBase;